module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.locked ? "list-of-portfolio locked" : "list-of-portfolio"
  }, [(!_vm.items.length) ? [_vm._v("\n\t\t" + _vm._s(_vm.data.nothing_to_show) + "\n\t")] : [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('div', {
      staticClass: "cols m_24 m__12 l_8 l___6 blockSol"
    }, [_c('div', {
      staticClass: "conentBlock"
    }, [_c('div', {
      staticClass: "image li"
    }, [_c('a', {
      attrs: {
        "href": item.button_right_link
      }
    }, [_c('img', {
      attrs: {
        "src": item.img || ((_vm.window.YAMASTERS_FRONTEND.templatePath) + "img/blockSolution.jpg"),
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "textContainer"
    }, [_c('div', {
      staticClass: "wr"
    }, [_c('div', {
      staticClass: "name "
    }, [_c('p', [_c('a', {
      attrs: {
        "href": item.header_link
      }
    }, [_vm._v(_vm._s(item.header))])]), _vm._v(" "), (item.cost) ? _c('p', {
      staticClass: "cost",
      domProps: {
        "innerHTML": _vm._s(item.cost)
      }
    }) : _vm._e(), _vm._v(" "), (item.lowcost) ? _c('p', {
      staticClass: "lowCost",
      domProps: {
        "innerHTML": _vm._s(item.lowcost)
      }
    }) : _vm._e()]), _vm._v(" "), (item.text) ? _c('div', {
      staticClass: "text"
    }, [_c('p', [_vm._v(_vm._s(item.text))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "topButton li"
    }, [(item.top_button) ? _c('a', {
      attrs: {
        "href": item.top_button_link
      }
    }, [_vm._v(_vm._s(item.top_button))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "botomButton li"
    }, [(item.botom_button) ? _c('a', {
      staticClass: "buttonLeft",
      attrs: {
        "target": "_blank",
        "href": item.botom_button_link
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.botom_button) + "\n\t\t\t\t\t\t")]) : _vm._e(), _vm._v(" "), _c('a', {
      staticClass: "buttonRight",
      attrs: {
        "href": item.button_right_link
      }
    }, [_vm._v("\n\t\t\t\t\t\t\t" + _vm._s(item.button_right) + "\n\t\t\t\t\t\t")])])])])]
  })], 2)]], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03ced2b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/lists/catalog.vue
// module id = 373
// module chunks = 14